import { Button } from '@salesforce/design-system-react';
import { NavigationProps, DataSource } from 'lib/types';
import * as React from 'react';
import * as Modal from 'react-modal';
import { withBrandData } from 'lib/withBrand';

import './auth-modal.css';

Modal.setAppElement('#modals');
if (Modal.defaultStyles.overlay) {
	Modal.defaultStyles.overlay.zIndex = 200;
	Modal.defaultStyles.overlay.backgroundColor = 'rgba(0,0,0,0)';
}

interface AuthModalProps extends NavigationProps {
	brandData: DataSource;
}

const AuthModal: React.SFC<AuthModalProps> = ({ brandData, navClick }) => (
	<Modal className="sources-auth" isOpen={true}>
		<div className="browser__titlebar">
			Allow Access? &nbsp;|&nbsp; Salesforce
		</div>
		<img className={'sources-auth__cloud-icon ' + brandData.src[1]} src={brandData.src[0]} />
			<h3 className="slds-text-heading_large">Allow Access from {brandData.name}?</h3>
		<div className="sources-auth__permission-list slds-m-around_medium">
			<p className="slds-m-vertical_small slds-p-left_x-small">Salesforce Customer 360 Data Manager is asking to:</p>
			<ul className="slds-m-around_medium slds-list_dotted">
				<li>Access your basic information</li>
				<li>Access and manage your data</li>
				<li>Provide access to your data via the Web</li>
				<li>Access and manage your Chatter data</li>
				<li>Provide access to custom applications</li>
				<li>Allow access to your unique identifier</li>
				<li>Access custom permissions</li>
				<li>Access and manage your data analytics</li>
				<li>Access and manage your data visualizations</li>
				<li>Perform requests on your behalf at any time</li>
			</ul>
			<Button label="Deny" />
			<Button label="Allow" variant="brand" onClick={navClick} />
		</div>
	</Modal>
);

export default withBrandData('source', AuthModal);


// WEBPACK FOOTER //
// ./src/DataSources/AuthModal.tsx